// Composer Studio — 템플릿 전역 속성 「제출 후 흐름」 저작 로직(순수 함수)
//
// 저작이 선언하는 것은 **흐름 하나**다: "작성을 마치면 무엇이 이어지는가"(`policy.postSubmit.flow`).
// 미선언이면 종전대로 제출에서 끝난다 — 결정 2026-09-06 §1.
//
// `./splitAxisPolicy`와 같은 층·같은 형태다(UI는 그리기만, 판정은 여기). 다른 점 하나:
// 분할 축은 화면에 편집 칸이 없는 세부 선언(행 표시명·그룹명 주입 칸)을 데리고 있어 끌 때 확인을
// 받지만, 흐름은 키 하나뿐이라 **잃을 것이 없다** — 없는 것을 잃는다고 물으면 안내가 거짓이다.
import type { TemplatePolicy } from '@safetyhub/shared';
import { POST_SUBMIT_FLOWS } from '@safetyhub/shared';

/**
 * 「제출 후 흐름」 select 선택지 — 「없음」 + 등록된 흐름들.
 *
 * 목록을 손으로 적지 않고 `POST_SUBMIT_FLOWS`(shared)에서 파생시킨다. 저작 select와 작성자가
 * 보는 전환 예고가 **같은 문구**여야 하기 때문이다(각자 적으면 고른 것과 보이는 것이 갈린다).
 */
export const POST_SUBMIT_FLOW_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: '', label: '없음' },
  ...POST_SUBMIT_FLOWS.map((f) => ({ value: f.key, label: f.name })),
];

/** select의 현재 값 — 미지정/빈 flow는 「없음」(서버 registry의 키 검증과 같은 판정). */
export function getPostSubmitFlow(policy: TemplatePolicy | undefined): string {
  const flow = policy?.postSubmit?.flow;
  return typeof flow === 'string' ? flow : '';
}

/**
 * 흐름 전환 결과 정책 — `''`(없음)이면 축 제거, 키면 그 키로 교체.
 *
 * `policy` 자체가 없던 템플릿에 흐름을 지정하면 정책 객체가 생긴다 — 저장 정규화
 * (`normalizeTemplatePolicy`)가 빈 정책을 null로 접으므로 「없음」 왕복은 원래 상태로 돌아간다.
 * 그 정규화는 원본을 spread로 출발해 이 축을 손대지 않으므로 등재할 화이트리스트가 없다.
 */
export function applyPostSubmitFlow(
  policy: TemplatePolicy | undefined,
  flow: string,
): TemplatePolicy {
  const next: TemplatePolicy = { ...policy };
  if (!flow) {
    delete next.postSubmit;
    return next;
  }
  next.postSubmit = { ...next.postSubmit, flow };
  return next;
}
